import format from 'date-fns/format';
import nl from 'date-fns/locale/nl';

const locales = { nl };

export default function (date, formatStr) {
  return format(date, formatStr, {
    locale: locales[window.__localeId__],
  });
};



// WEBPACK FOOTER //
// ./src/utils/format.js